// react-query
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";

export const useCorporateListWithAgencies = () => {
    return useQuery({
        queryKey: ['corporateListWithAgencies'],
        queryFn: async () => {
            const response = await axiosInstance.get(paths.corporateListWithAgencies);

            const formattedData = response.data.map(item => ({
                label: item.name,
                options: item.agencies.map(agency => ({
                    value: agency.id,
                    label: agency.name,
                })),
            }));

            return formattedData;
        },
        staleTime: 0,
        cacheTime: 0,
    });
};